/**
 * Common conversion constants
 */
export const CONVERSION_CONSTANTS = {
  /** Conversion factor between seconds and milliseconds (1 second = 1000 milliseconds) */
  SECOND_MS_FACTOR: 1000,
  /** Seconds in a minute */
  SECONDS_PER_MINUTE: 60,
  /** Minutes in an hour */
  MINUTES_PER_HOUR: 60,
  /** Hours in a day */
  HOURS_PER_DAY: 24,
  /** Bytes in a kilobyte (1024 bytes = 1 KB) */
  BYTES_PER_KB: 1024,
  /** Decimal precision factor for rounding (multiply by 100 for 2 decimal places) */
  DECIMAL_PRECISION_FACTOR: 100,
  /** Month adjustment factor (JavaScript months are 0-based, so add 1 for display) */
  MONTH_ADJUSTMENT: 1
} as const;

/**
 * Time constants in seconds
 */
export const TIME_SECONDS = {
  /** 1 minute in seconds */
  MINUTE: CONVERSION_CONSTANTS.SECONDS_PER_MINUTE,
  /** 1 hour in seconds */
  HOUR: CONVERSION_CONSTANTS.MINUTES_PER_HOUR * CONVERSION_CONSTANTS.SECONDS_PER_MINUTE,
  /** 1 day in seconds */
  DAY:
    CONVERSION_CONSTANTS.HOURS_PER_DAY * CONVERSION_CONSTANTS.MINUTES_PER_HOUR * CONVERSION_CONSTANTS.SECONDS_PER_MINUTE
} as const;

/**
 * Time constants in milliseconds
 */
export const TIME_MS = {
  /** 1 second in milliseconds */
  SECOND: CONVERSION_CONSTANTS.SECOND_MS_FACTOR,
  /** 1 minute in milliseconds */
  MINUTE: TIME_SECONDS.MINUTE * CONVERSION_CONSTANTS.SECOND_MS_FACTOR,
  /** 1 hour in milliseconds */
  HOUR: TIME_SECONDS.HOUR * CONVERSION_CONSTANTS.SECOND_MS_FACTOR,
  /** 1 day in milliseconds */
  DAY: TIME_SECONDS.DAY * CONVERSION_CONSTANTS.SECOND_MS_FACTOR
} as const;
